import { Component, OnInit, Input } from '@angular/core';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';
import { MainHeaderlabel_EN } from 'src/app/models/labels/mainHeaderLabel_EN';
import { SessionExpiryLabel_EN } from 'src/app/models/labels/sessionExpiryLabel_EN';
import { Router } from '@angular/router';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';
import { AuthorisationService } from 'src/app/services/authorisation/authorisation.service';
import { QuoteRenderingService } from 'src/app/services/search/quote-rendering.service';
import { BorrowerDTO } from 'src/app/models/borrower/borrower-dto';
import { IncomeDTO } from 'src/app/models/borrower/income-dto';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { Parameter } from 'src/app/models/borrower/loanFormParameter';
import { NewQuote } from 'src/app/models/search/new-quote';
import { QuotationEntityIdDto } from 'src/app/models/search/quotation-entity-id-dto';
import { SearchQuote } from 'src/app/models/search/search-quote';
import { LoanStep3 } from 'src/app/models/borrower/loan-step3';
import { LoanStep4 } from 'src/app/models/borrower/loan-step4';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {

  @Input() displayMessage: string;
  @Input() imgSource: string;
  @Input() route: string;
  @Input() id: string;

  headerLabel: any;
  footerLabel: any;
  message: any;

  env: string = environment.apiURL.env;
  nissanUrl: string = environment.apiURL.nUrl;
  preprodUrl: string = environment.apiURL.preUrl;

  preprod: boolean = false;

  constructor(private router: Router, private borrowerService: BorrowerRenderingService,
    private authorisationService: AuthorisationService,
    private quoteService: QuoteRenderingService) { }

  ngOnInit() {
    this.headerLabel = new MainHeaderlabel_EN();
    this.footerLabel = new FooterLabel_EN();
    this.message = new SessionExpiryLabel_EN();
    localStorage.removeItem("SSOLOGIN");
    this.authorisationService.logout();
    if (this.env.includes('preprod'))
      this.preprod = true;
    else
      this.preprod = false;
     console.log(this.env+'preprod===', this.preprod);
    return this.preprod;
  }

  loginPage() {
    this.authorisationService.logout();


    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.loanStep3 = new LoanStep3();
    this.borrowerService.loanStep4 = new LoanStep4();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;


    this.router.navigate(['/login']);
  }
  home() {


    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.loanStep3 = new LoanStep3();
    this.borrowerService.loanStep4 = new LoanStep4();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;


    this.router.navigate(['/home']);
  }

}
